export default function (context, inject) {
  // 从上下文中获取 $axios 和 $cookies
  const { $axios, $cookies } = context;

  // 创建自定义的 axios 实例
  const api = $axios.create({
    baseURL: context.$config.apiBaseUrl
  });

  // 请求拦截器：从 cookie 中获取 token 并设置到请求头
  api.onRequest((config) => {
    const token = $cookies.get('eduHungaryC_token');
    if (token) {
      config.headers.Authorization = token
    }
    return config;
  });

  // 响应拦截器：处理错误，例如 token 过期
  api.onResponseError((error) => {
    const code = error.response?.status;
    if (code === 500) {
      // 处理 token 过期或未授权
      // 例如：清除 cookie 中的 token，跳转到登录页
      context.store.dispatch('clearUserData')
      $cookies.remove('eduHungaryC_token');
      context.redirect('/');
    }
    return Promise.reject(error);
  });

  // 封装 API 方法
  const apiService = {
    get: (url, config) => api.$get(url, config),
    post: (url, data, config) => api.$post(url, data, config),
    put: (url, data, config) => api.$put(url, data, config),
    delete: (url, config) => api.$delete(url, config)
  };

  // 注入到 context 和 Vue 实例
  inject('api', apiService);
}